import React, { useEffect } from 'react';
import { Modal, Form, Input, Select, message } from 'antd';
import { useCreateDataGroupMutation, useUpdateDataGroupMutation } from '../../../redux/api/compassPortal';

const CATEGORY_OPTIONS = [
    'Paid Digital Marketing',
    'Influencer',
    'CRM/Other',
    'Organic',
    'Offline',
];

const DataGroupModal = ({ open, onClose, projectId, editingGroup }) => {
    const [form] = Form.useForm();
    const [createGroup, { isLoading: isCreating }] = useCreateDataGroupMutation();
    const [updateGroup, { isLoading: isUpdating }] = useUpdateDataGroupMutation();

    const isEditing = !!editingGroup;

    useEffect(() => {
        if (open && editingGroup) {
            form.setFieldsValue({
                name: editingGroup.name,
                category: editingGroup.category || undefined,
                purpose: editingGroup.purpose || '',
            });
        }
    }, [open, editingGroup, form]);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            if (isEditing) {
                await updateGroup({
                    projectId,
                    groupId: editingGroup.group_id,
                    name: values.name,
                    purpose: values.purpose || '',
                    category: values.category || '',
                }).unwrap();
            } else {
                await createGroup({
                    projectId,
                    name: values.name,
                    purpose: values.purpose || '',
                    category: values.category || '',
                }).unwrap();
            }
            message.success(isEditing ? 'Data group updated' : `Data group "${values.name}" created`);
            form.resetFields();
            onClose();
        } catch (err) {
            if (!err?.errorFields) message.error('Failed to save data group');
        }
    };

    return (
        <Modal
            title={isEditing ? 'Edit Data Group' : 'Create Data Group'}
            open={open}
            onOk={handleOk}
            onCancel={onClose}
            confirmLoading={isCreating || isUpdating}
            okText={isEditing ? 'Update' : 'Create'}
            destroyOnClose
        >
            <Form form={form} layout="vertical" preserve={false}>
                <Form.Item
                    name="name"
                    label="Group Name"
                    rules={[{ required: true, message: 'Please enter a group name' }]}
                >
                    <Input placeholder="e.g. Paid Marketing - Online" />
                </Form.Item>
                <Form.Item name="category" label="Category">
                    <Select
                        placeholder="Select a category"
                        allowClear
                        showSearch
                        options={CATEGORY_OPTIONS.map((c) => ({ label: c, value: c }))}
                    />
                </Form.Item>
                <Form.Item name="purpose" label="Purpose">
                    <Input.TextArea rows={3} placeholder="Describe the purpose of this group" />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default DataGroupModal;
